function initAdminUsersTable() {
	var table = document.getElementById('admin-users-table');
	if (!table) {
		return;
	}

	$('#admin-users-table').DataTable();
}

function initAdminUserActivityTable() {
	var table = document.getElementById('admin-user-activity-table');
	if (!table) {
		return;
	}

	$('#admin-user-activity-table').DataTable({
		order: [[1, 'desc']],
		pageLength: 10
	});
}

function initAdminServicesTable() {
	var table = document.getElementById('admin-services-table');
	if (!table) {
		return;
	}

	$('#admin-services-table').DataTable({
		language: {
			emptyTable: table.dataset.emptyMessage || 'No data available in table'
		}
	});
}

function initialiseMenuSidebarPersistence() {
    const sidebarPanel = document.getElementById('team-sidebar-panel-content');
    if (!sidebarPanel) return;

    const persistPreference = (isExpanded) => {
        const maxAge = 365 * 24 * 60 * 60;
        document.cookie = `pref_sidebarExpanded=${isExpanded}; path=/; max-age=${maxAge}; SameSite=Lax`;
    };

    // Save when the transition starts, including navigation before it finishes.
    $(sidebarPanel).on('show.bs.collapse hide.bs.collapse', (event) => {
        if (event.target === sidebarPanel) {
            persistPreference(event.type === 'show');
        }
    });

    const sidebar = sidebarPanel.closest('.team-admin-sidebar');
    sidebar?.querySelectorAll('.team-admin-menu-link, .team-admin-menu-button-compact').forEach(link => {
        link.addEventListener('click', () => {
            if (window.innerWidth < 992) {
                persistPreference(false);
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
	initialiseMenuSidebarPersistence();
	initAdminUserActivityTable();
});
